import React from "react";
import "./About.css";
import group from "./images/about/group.png";
import line from "./images/about/line.png";

function About() {
  return (
    <div className="aboutOuter">
      <div className="container">
        <div className="aboutInner" id="about">
          <div className="aboutinner_upper">
            <p>We are here for your tax relief</p>
          </div>
          <div className="aboutinner_middle">
            <div className="aboutus_heading">
              <div className="aboutus_smallheading">About Us</div>
              <div className="aboutus_line">
                <img src={line} alt="" />
              </div>
            </div>

            <div className="aboutus_content">
              <div className="aboutus_leftcontent">
                We help our clients to handle their Business or Professional tax
                Compliances
              </div>
              <div className="aboutus_rightcontent">
                Founded in 2016 by a team of dedicated Chartered Accountants, our firm is devoted to streamlining personal finance and ensuring seamless tax compliance for individuals and entities engaged in employment, business, or professional activities. Our guiding principle is to demystify taxation by delivering clear, effective, and personalized financial solutions.
                <br /> <br />
                We offer specialized services in Income Tax filing, offshore accounting, and bookkeeping, providing expert counsel and steadfast support to both individuals and businesses. Our seasoned professionals guarantee the accurate and timely submission of returns, while strategically maximizing deductions and minimizing tax liabilities.
                <br /> <br />
                With an unwavering commitment to efficiency, precision, and integrity, we aim to be your trusted partner in navigating the intricacies of taxation and financial management.
              </div>
            </div>
          </div>
          <div className="aboutinner_last">
            <div className="aboutlast_img">
              <img src={group} alt="" />
            </div>
            <div className="aboutlast_content">
              <div className="aboutlast_content_heading">
                Empowering you to make sound financial decisions by controlling
                your taxes and learning about
              </div>
              <div className="aboutlast_content_p">
                <p>Income Tax Returns</p>
                <p>Advance tax payment & Tax liability</p>
                <p>Annual information statement (AIS) and 26 AS </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
